<template>
    <div>
        <div class="container-fluid mt-6"
             v-if="course && course.advantage_name_1">
            <div class="container">
                <div class="row">
                    <div class="col-12 adv-header">
                        {{ $t('course_advantages') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid"
             v-if="course && course.advantage_name_1">
            <div class="container mt-6">
                <div class="row adv-item" v-if="course.advantage_name_1">
                    <div class="col-12 col-lg-4 adv-image adv-bg-1">
                        <span v-if="course.advantage_icon_1"><img :src="course.advantage_icon_1"></span>
                        <span v-else><img src="@/assets/poliglotiki/images/adv-bird-1.png"></span>
                    </div>
                    <div class="col-12 col-lg-3 adv-title">
                        {{ course.advantage_name_1 }}
                    </div>
                    <div class="col-12  col-lg-4 offset-lg-1 adv-text pr-4">
                        {{ course.advantage_text_1 }}
                    </div>
                </div>
                <div class="row adv-item" v-if="course.advantage_name_2">
                    <div class="col-12 col-lg-4 adv-image adv-bg-2">
                        <span v-if="course.advantage_icon_2"><img :src="course.advantage_icon_2"></span>
                        <span v-else><img src="@/assets/poliglotiki/images/adv-bird-2.png"></span>
                    </div>
                    <div class="col-12 col-lg-3 adv-title">
                        {{ course.advantage_name_2 }}
                    </div>
                    <div class="col-12  col-lg-4 offset-lg-1 adv-text pr-4">
                        {{ course.advantage_text_2 }}
                    </div>
                </div>
                <div class="row adv-item" v-if="course.advantage_name_3">
                    <div class="col-12 col-lg-4 adv-image adv-bg-3">
                        <span v-if="course.advantage_icon_3"><img :src="course.advantage_icon_3"></span>
                        <span v-else><img src="@/assets/poliglotiki/images/adv-bird-3.png"></span>
                    </div>
                    <div class="col-12 col-lg-3 adv-title">
                        {{ course.advantage_name_3 }}
                    </div>
                    <div class="col-12  col-lg-4 offset-lg-1 adv-text pr-4">
                        {{ course.advantage_text_3 }}
                    </div>
                </div>
                <div class="row adv-item" v-if="course.advantage_name_4">
                    <div class="col-12 col-lg-4 adv-image adv-bg-4">
                        <span v-if="course.advantage_icon_4"><img :src="course.advantage_icon_4"></span>
                        <span v-else><img src="@/assets/poliglotiki/images/adv-bird-4.png"></span>
                    </div>
                    <div class="col-12 col-lg-3 adv-title">
                        {{ course.advantage_name_4 }}
                    </div>
                    <div class="col-12  col-lg-4 offset-lg-1 adv-text pr-4">
                        {{ course.advantage_text_4 }}
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->
    </div>
</template>

<script>

    export default {
        name: 'CourseAdvantages',

        props: {
            course: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {}
        },

        mounted() {
        },

    }
</script>

<style scoped>

    .adv-item {
        min-height: 217px;
    }

    .adv-bg-1 {
        background-image: url('~@/assets/poliglotiki/images/adv-bg-1.png');
    }

    .adv-bg-2 {
        background-image: url('~@/assets/poliglotiki/images/adv-bg-2.png');
    }

    .adv-bg-3 {
        background-image: url('~@/assets/poliglotiki/images/adv-bg-3.png');
    }

    .adv-bg-4 {
        background-image: url('~@/assets/poliglotiki/images/adv-bg-4.png');
    }

    .adv-image {
        background-position: left center;
        background-repeat: no-repeat;

        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        text-align: center;
    }

    .adv-header {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #231c37;
        text-align: center;
    }

    .adv-title {
        font-family: "Manrope Bold";
        font-size: 24px;
        line-height: 30px;
        color: #5ab947;
        padding-top: 40px;
    }

    .adv-text {
        color: #4f4d5c;
        font-size: 15px;
        line-height: 18px;
        padding-top: 40px;
    }


    @media (min-width: 992px) {
        .adv-item {
            border: 1px solid #d7e1e5;
            margin-top: -1px;
        }

    }

    @media (max-width: 991.8px) {
        .adv-item {
            border-top: 1px solid #d7e1e5;
            margin-bottom: 40px;
            padding-right: 15px;
            padding-left: 15px;
        }

        .adv-image {
            background-position: top center;
            padding-top: 30px;
        }
    }
</style>
